import { fetchWeatherApi } from "openmeteo";

const PARAMS = {
  latitude: 39.900884,
  longitude: -105.0860904,
  daily: [
    "weather_code",
    "temperature_2m_max",
    "temperature_2m_min",
    "precipitation_probability_max",
  ],
  hourly: ["temperature_2m", "is_day", "weather_code"],
  current: [
    "temperature_2m",
    "cloud_cover",
    "weather_code",
    "precipitation",
    "rain",
    "showers",
    "snowfall",
    "is_day",
  ],
  timezone: "America/Denver",
  temperature_unit: "fahrenheit",
  precipitation_unit: "inch",
};
const URL = "https://api.open-meteo.com/v1/forecast";

function getDateString(now) {
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(now.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function getTomorrowDateString() {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return getDateString(tomorrow);
}

function weatherDescription(
  day_description,
  night_description,
  day_background,
  night_background,
  day_font_color,
  night_font_color
) {
  return {
    day: day_description,
    night: night_description ? night_description : day_description,
    day_background: day_background,
    night_background: night_background,
    day_font_color: day_font_color,
    night_font_color: night_font_color,
  };
}

const FONT_DARK = "#1e2938";
const FONT_LIGHT = "white";

const WEATHER_DESCRIPTIONS = {
  0: weatherDescription(
    "Sunny",
    "Clear Night",
    "DayClear",
    "NightClear",
    FONT_DARK,
    FONT_LIGHT
  ),
  1: weatherDescription(
    "Mostly Sunny",
    "MostlyClear",
    "DayMostlyClear",
    "NightMostlyClear",
    FONT_DARK,
    FONT_LIGHT
  ),
  2: weatherDescription(
    "Partly Cloudy",
    null,
    "DayMostlyCloudy",
    "NightMostlyCloudy",
    FONT_DARK,
    FONT_LIGHT
  ),
  3: weatherDescription(
    "Overcast",
    null,
    "DayOvercast",
    "NightOvercast",
    FONT_DARK,
    FONT_LIGHT
  ),
  45: weatherDescription(
    "Foggy",
    null,
    "DayFoggy",
    "NightFoggy",
    FONT_DARK,
    FONT_LIGHT
  ),
  48: weatherDescription(
    "Foggy",
    null,
    "DayFoggy",
    "NightFoggy",
    FONT_DARK,
    FONT_LIGHT
  ),
  51: weatherDescription(
    "Light Drizzle",
    null,
    "DayLightRain",
    "NightLightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  53: weatherDescription(
    "Drizzle",
    null,
    "DayLightRain",
    "NightLightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  55: weatherDescription(
    "Dense Drizzle",
    null,
    "DayLightRain",
    "NightLightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  56: weatherDescription(
    "Freezing Drizzle (Light)",
    null,
    "DayLightRain",
    "NightLightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  57: weatherDescription(
    "Freezing Drizzle",
    null,
    "DayLightRain",
    "NightLightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  61: weatherDescription(
    "Light Rain",
    null,
    "DayLightRain",
    "NightLightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  63: weatherDescription(
    "Rain",
    null,
    "DayRain",
    "NightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  65: weatherDescription(
    "Heavy Rain",
    null,
    "DayHeavyRain",
    "NightHeavyRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  66: weatherDescription(
    "Freezing Rain",
    null,
    "DayRain",
    "NightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  67: weatherDescription(
    "Heavy Freezing Rain",
    null,
    "DayHeavyRain",
    "NightHeavyRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  71: weatherDescription(
    "Light Snow",
    null,
    "DayLightSnow",
    "NightLightSnow",
    FONT_DARK,
    FONT_LIGHT
  ),
  73: weatherDescription(
    "Snow",
    null,
    "DaySnow",
    "NightSnow",
    FONT_DARK,
    FONT_LIGHT
  ),
  75: weatherDescription(
    "Heavy Snow",
    null,
    "DayHeavySnow",
    "NightHeavySnow",
    FONT_DARK,
    FONT_LIGHT
  ),
  77: weatherDescription(
    "Light Snow",
    null,
    "DayLightSnow",
    "NightLightSnow",
    FONT_DARK,
    FONT_LIGHT
  ),
  80: weatherDescription(
    "Light Rain Showers",
    null,
    "DayLightRain",
    "NightLightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  81: weatherDescription(
    "Rain Showers",
    null,
    "DayRain",
    "NightRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  82: weatherDescription(
    "Violent Rain Showers",
    null,
    "DayHeavyRain",
    "NightHeavyRain",
    FONT_DARK,
    FONT_LIGHT
  ),
  85: weatherDescription(
    "Snow Showers",
    null,
    "DaySnow",
    "NightSnow",
    FONT_DARK,
    FONT_LIGHT
  ),
  86: weatherDescription(
    "Heavy Snow Showers",
    null,
    "DayHeavySnow",
    "NightHeavySnow",
    FONT_DARK,
    FONT_LIGHT
  ),
  95: weatherDescription(
    "Thunderstorms",
    null,
    "DayThunderstorms",
    "NightThunderstorms",
    FONT_DARK,
    FONT_LIGHT
  ),
  96: weatherDescription(
    "Thunderstorms with Hail",
    null,
    "DayThunderstorms",
    "NightThunderstorms",
    FONT_DARK,
    FONT_LIGHT
  ),
  99: weatherDescription(
    "Heavy Thunderstorms with Hail",
    null,
    "DayThunderstorms",
    "NightThunderstorms",
    FONT_DARK,
    FONT_LIGHT
  ),
};

function getDescription(code, is_day) {
  let data = WEATHER_DESCRIPTIONS[code];
  return is_day ? data.day : data.night;
}

function getBackground(code, is_day) {
  let data = WEATHER_DESCRIPTIONS[code];
  return is_day ? data.day_background : data.night_background;
}

function getFontColor(code, is_day) {
  let data = WEATHER_DESCRIPTIONS[code];
  return is_day ? data.day_font_color : data.night_font_color;
}

function extractWeatherData(data) {
  const utcOffsetSeconds = data.utcOffsetSeconds();
  const current = data.current();
  const hourly = data.hourly();
  const daily = data.daily();

  const weatherData = {
    current: {
      time: new Date((Number(current.time()) + utcOffsetSeconds) * 1000),
      temperature2m: current.variables(0).value(),
      cloudCover: current.variables(1).value(),
      weatherCode: current.variables(2).value(),
      precipitation: current.variables(3).value(),
      rain: current.variables(4).value(),
      showers: current.variables(5).value(),
      snowfall: current.variables(6).value(),
      isDay: current.variables(7).value(),
    },
    hourly: {
      time: [
        ...Array(
          (Number(hourly.timeEnd()) - Number(hourly.time())) / hourly.interval()
        ),
      ].map(
        (_, i) =>
          new Date(
            (Number(hourly.time()) + i * hourly.interval() + utcOffsetSeconds) *
              1000
          )
      ),
      temperature2m: hourly.variables(0).valuesArray(),
      isDay: hourly.variables(1).valuesArray(),
      weatherCode: hourly.variables(2).valuesArray(),
    },
    daily: {
      time: [
        ...Array(
          (Number(daily.timeEnd()) - Number(daily.time())) / daily.interval()
        ),
      ].map(
        (_, i) =>
          new Date(
            (Number(daily.time()) + i * daily.interval() + utcOffsetSeconds) *
              1000
          )
      ),
      weatherCode: daily.variables(0).valuesArray(),
      temperature2mMax: daily.variables(1).valuesArray(),
      temperature2mMin: daily.variables(2).valuesArray(),
      precipitationProbabilityMax: daily.variables(3).valuesArray(),
    },
  };

  // Description
  weatherData.current.description = getDescription(
    weatherData.current.weatherCode,
    weatherData.current.isDay
  );
  weatherData.daily.description = Array.from(weatherData.daily.weatherCode).map(
    (code) => {
      return getDescription(code, weatherData.current.isDay);
    }
  );
  weatherData.hourly.description = Array.from(
    weatherData.hourly.weatherCode
  ).map((code) => {
    return getDescription(code, weatherData.current.isDay);
  });

  // Background
  weatherData.current.background = getBackground(
    weatherData.current.weatherCode,
    weatherData.current.isDay
  );
  weatherData.daily.background = Array.from(weatherData.daily.weatherCode).map(
    (code) => {
      return getBackground(code, weatherData.current.isDay);
    }
  );
  weatherData.hourly.background = Array.from(
    weatherData.hourly.weatherCode
  ).map((code) => {
    return getBackground(code, weatherData.current.isDay);
  });

  // Font Color
  weatherData.current.font_color = getFontColor(
    weatherData.current.weatherCode,
    weatherData.current.isDay
  );
  weatherData.daily.font_color = Array.from(weatherData.daily.weatherCode).map(
    (code) => {
      return getFontColor(code, weatherData.current.isDay);
    }
  );
  weatherData.hourly.font_color = Array.from(
    weatherData.hourly.weatherCode
  ).map((code) => {
    return getFontColor(code, weatherData.current.isDay);
  });

  weatherData.daily = {
    time: weatherData.daily.time[0],
    description: weatherData.daily.description[0],
    background: weatherData.daily.background[0],
    font_color: weatherData.daily.font_color[0],
    weatherCode: weatherData.daily.weatherCode[0],
    temperature2mMax: weatherData.daily.temperature2mMax[0],
    temperature2mMin: weatherData.daily.temperature2mMin[0],
    precipitationProbabilityMax:
      weatherData.daily.precipitationProbabilityMax[0],
  };

  return weatherData;
}

export async function getWeatherData() {
  PARAMS.start_date = getDateString(new Date());
  PARAMS.end_date = getTomorrowDateString();

  const responses = await fetchWeatherApi(URL, PARAMS);
  return extractWeatherData(responses[0]);
}
